export enum MapRenderMethod {
  GEOJSON = 'GEOJSON',
  LEGACY = 'LEGACY',
}
